import React from 'react';
import { localize } from '../Util/L10n';
import { Accordion, AccordionItem } from './Accordion';
import { Legend } from './Legend';
import Module from './Module';
import { TwoColumns } from './TwoColumns';
import { Route, Switch, withRouter } from 'react-router-dom';
import ElectiveModules from './ElectiveModules';
import { getPath } from '../Util/Paths';

class Semester extends React.Component {
  electiveModules = (modules) => {
    return modules.filter((module) => module.placeholderType === 1);
  };

  render() {
    const { semester } = this.props;
    const listedModules = semester.modules;

    return (
      <Switch>
        <Route path={getPath('compulsory')}>
          <ElectiveModules
            modules={this.electiveModules(semester.modules)}
            mandatoryModules={semester.mandatoryModules}
            onModuleChange={this.props.onModuleChange}
            selectedModules={this.props.selectedModules}
            semesterUid={semester.uid}
          />
        </Route>
        <Route path={getPath('semester')}>
          <TwoColumns
            left={
              <React.Fragment>
                <img src={semester.images[0]} className="img-fluid" />
                <h3>{semester.name}</h3>
                <div
                  dangerouslySetInnerHTML={{
                    __html: semester.description,
                  }}
                />
                <Accordion open={0}>
                  <AccordionItem title={localize('semestersLegendTitle')}>
                    <Legend modules={listedModules} />
                  </AccordionItem>
                </Accordion>
              </React.Fragment>
            }
            right={
              <div className="space-y-sm text-white">
                {listedModules.map((module) => (
                  <Module key={module.uid} module={module} />
                ))}
              </div>
            }
          />
        </Route>
      </Switch>
    );
  }
}

export default withRouter(Semester);
